// File: src/components/Answer/AnswerLoading.tsx

import React from "react";
import styles from "./Answer.module.css";
import { AnswerIcon } from "./AnswerIcon";

export const AnswerLoading: React.FC = () => {
    return (
        <div className={styles.answerContainer}>
            <AnswerIcon />
            <div className={styles.answerContent}>
                <div className={styles.answerText}>
                    <div className={styles.processingMessage}>
                        <span className={styles.dot}></span>
                        <span className={styles.dot}></span>
                        <span className={styles.dot}></span>
                    </div>
                </div>
            </div>
        </div>
    );
};
